/**
 * Team V2 Repository - GraphQL Mutations
 *
 * 7 mutation operations for Team primitive data modification.
 * All mutations use TEAM_FIELDS_FRAGMENT for consistency.
 *
 * Signatures match deploy/router/schemas/core.graphql exactly.
 * Backend resolves tenantId from auth context — NOT passed as parameter.
 */

import { gql } from '@apollo/client';
import { TEAM_FIELDS_FRAGMENT } from './fragments';

export const CREATE_TEAM = gql`
  ${TEAM_FIELDS_FRAGMENT}
  mutation CreateTeam($input: GqlCreateTeamInput!) {
    createTeam(input: $input) {
      ...TeamFields
    }
  }
`;

export const UPDATE_TEAM = gql`
  ${TEAM_FIELDS_FRAGMENT}
  mutation UpdateTeam($code: String!, $input: GqlUpdateTeamInput!) {
    updateTeam(code: $code, input: $input) {
      ...TeamFields
    }
  }
`;

export const ARCHIVE_TEAM = gql`
  mutation ArchiveTeam($code: String!, $reason: String!) {
    archiveTeam(code: $code, reason: $reason) {
      success
      archivedAt
      archivedBy
      reason
      message
      teamCode
      teamName
    }
  }
`;

export const MOVE_TEAM = gql`
  ${TEAM_FIELDS_FRAGMENT}
  mutation MoveTeam($input: GqlMoveTeamInput!) {
    moveTeam(input: $input) {
      ...TeamFields
    }
  }
`;

export const ADD_STAKEHOLDER = gql`
  ${TEAM_FIELDS_FRAGMENT}
  mutation AddTeamStakeholder($input: GqlAddStakeholderInput!) {
    addTeamStakeholder(input: $input) {
      ...TeamFields
    }
  }
`;

export const REMOVE_STAKEHOLDER = gql`
  ${TEAM_FIELDS_FRAGMENT}
  mutation RemoveTeamStakeholder($input: GqlRemoveStakeholderInput!) {
    removeTeamStakeholder(input: $input) {
      ...TeamFields
    }
  }
`;

export const UPDATE_TEAM_QUOTAS = gql`
  ${TEAM_FIELDS_FRAGMENT}
  mutation UpdateTeamQuotas($input: GqlUpdateTeamQuotasInput!) {
    updateTeamQuotas(input: $input) {
      ...TeamFields
    }
  }
`;
